import type { Resource } from '../../';
export const general_errors_notFound_bodyMessage1: Resource = {"default":"The page you have requested does not exist or is no longer available."};
